export default function() {
  return {
    notificationsCount: 0,
    toasts: [],
    activeRibbon: null,
    pageVisible: true
  };
}
